module.exports = __webpack_public_path__ + "img/hero_sp.178edb31.jpg";